import { cn } from "../lib/cn.js";
import type { PasswordCheck } from "../lib/password.js";

const STRENGTH_COLOR = ["", "bg-destructive", "bg-amber-500", "bg-blue-500", "bg-emerald-500"] as const;

/** A four-segment length-based strength bar. Hidden until the user starts typing. */
export function PasswordStrengthMeter({
  check,
  shown,
}: {
  readonly check: PasswordCheck;
  readonly shown: boolean;
}): React.JSX.Element | null {
  if (!shown) return null;
  return (
    <div className="mt-1 flex items-center gap-2">
      <div className="flex flex-1 gap-1" aria-hidden="true">
        {[1, 2, 3, 4].map((segment) => (
          <span
            key={segment}
            className={cn(
              "h-1.5 flex-1 rounded-full transition-colors",
              segment <= check.strength ? STRENGTH_COLOR[check.strength] : "bg-muted",
            )}
          />
        ))}
      </div>
      <span className="text-muted-foreground w-16 shrink-0 text-right text-xs">{check.strengthLabel}</span>
    </div>
  );
}
